import React from "react";

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
  }).format(value);
};

export function discountedPrice(precioVenta, porcentaje) {
  return Math.round(precioVenta * (1 - porcentaje) * 100) / 100;
}

export function getActiveDiscount(product) {
  const rel = product.descuentos?.[0];
  if (rel) {
    const qtyOk =
      rel.cantidadDisponible === null || rel.cantidadDisponible > 0;
    if (
      qtyOk &&
      new Date(rel.validoDesde) <= new Date() &&
      new Date(rel.validaHasta) >= new Date() &&
      rel.activo
    ) {
      return rel;
    }
  }
  if (
    product.descuento > 0 &&
    (product.unidadesDisponiblesDescuento === null ||
      product.unidadesDisponiblesDescuento > 0)
  ) {
    return { porcentaje: product.descuento, soloEnEfectivo: false };
  }
  return null;
}

function DiscountBadge({ compact }) {
  const size = compact
    ? "h-10 min-h-[2.5rem] px-2 text-[10px]"
    : "h-14 min-h-[3.5rem] px-3 text-xs";
  return (
    <div
      className={`flex shrink-0 rounded-full bg-green text-white font-bold items-center justify-center ${size}`}
    >
      Descuento
    </div>
  );
}

export function ProductPrice({ product, color, hideDiscountText }) {
  const textColor = color || "text-listingProductGray";
  const descuento = getActiveDiscount(product);

  if (!descuento) {
    return (
      <div className="mt-4">
        <p className={`${textColor} text-lg`}>
          {formatCurrency(product.precioVenta)}
          <br />
          <span className={`${textColor} text-xs`}>
            I.V.A. incluido
            {!hideDiscountText && (
              <>
                <br />
                Precio Regular
              </>
            )}
          </span>
        </p>
      </div>
    );
  }

  const precioConDescuento = discountedPrice(
    product.precioVenta,
    descuento.porcentaje
  );

  return (
    <div className="mt-4">
      <div className="flex gap-3 items-center">
        <p className="font-semibold text-xl text-green">
          {formatCurrency(precioConDescuento)}
          {!hideDiscountText && "*"}
        </p>
        <DiscountBadge compact={hideDiscountText} />
      </div>
      <p className={`${textColor} text-sm line-through mt-1`}>
        {formatCurrency(product.precioVenta)}
      </p>
      <span className={`${textColor} text-xs`}>I.V.A. incluido</span>
      {!hideDiscountText && (
        <span className={`${textColor} text-xs block mt-2`}>
          *Precio con descuento (IVA incluido){" "}
          {descuento.soloEnEfectivo && "pagando en efectivo"}{" "}
          (Por tiempo limitado. Aplica restricciones según inventario)
        </span>
      )}
    </div>
  );
}

export default ProductPrice;
